import { getConfigWithMetadata } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils/error';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { type AutoSuggestionListingResponse, commonPropertySuggest, type Language } from '@generated/search-bff';

export type GetSuggestionsByDisplayIdOptions = {
  limit: number;
  language: Language;
};

/**
 * Fetch suggestions based on a partial or full display ID using the `/api/v2/autosuggestion/listing/suggest` endpoint.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/autosuggestion/getSuggestionsByDisplayId Search API Documentation}
 */
export async function getSuggestionsByDisplayId(
  input: string,
  options: GetSuggestionsByDisplayIdOptions,
  apiConfig: ApiConfig,
): Promise<ApiResult<AutoSuggestionListingResponse[]>> {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'getSuggestionsByDisplayId');

    const response = await commonPropertySuggest(
      {
        input,
        limit: options.limit,
        language: options.language,
      },
      _apiConfig,
    );
    return {
      status: 'success',
      data: response,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
